// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3-x5iYH-KaRX03e7CL5Ckv","button":"_1bwxJusO8l0cNjXXSEVHxU"};